import Select from './select.vue';

export default Select;


// WEBPACK FOOTER //
// ./src/components/select/index.js